import {ISearchFilters, ISearchType} from "./SearchPage";
import FilesList from "../../components/blocks/TerracedGridTheme/FilesFoldersBlock/FilesList";
import React, {Dispatch, SetStateAction, useContext, useState} from "react";
import {ResultsHOC} from "./ResultsHOC";
import {
    IReactiveFileContentItem,
    IReactiveFolderContentItem,
} from "../../stores/SchoolFeedStore";
import {StoreContext} from "../../stores/StoreContext";
import {isSchoolBlocksApp} from "../../utils/SchoolBlocksUtilities";
import {ExpandYourSearchInfoBox} from "./PageSearchResults";
import {PaginationFooter} from "./PaginationFooter";

export function FilesAndFoldersResults(props: {
    searchTypes: ISearchType[],
    setSearchTypes: Dispatch<SetStateAction<ISearchType[]>>
    results: {
        google_drive?: {
            data: Array<IReactiveFileContentItem | IReactiveFolderContentItem>,
            meta: {
                total: number,
            }
        }
        files_and_folders?: {
            data: Array<IReactiveFileContentItem | IReactiveFolderContentItem>,
            meta: {
                total: number,
            }
        }
    },
    isValidating: boolean,
    searchTerm: string,
    setFilters: Dispatch<SetStateAction<ISearchFilters>>,
    filters: ISearchFilters,
}) {
    const {organizationStore} = useContext(StoreContext);
    const isSchoolBlocks = isSchoolBlocksApp()
    const googleDriveResults = props.searchTypes.includes("google_drive")
    const dataset = googleDriveResults ? props.results?.google_drive : props.results?.files_and_folders
    const data = dataset?.data || [];
    const total = dataset?.meta?.total || 0;
    const pageSize = props.filters["files_and_folders.page_size"];
    const page = props.filters["files_and_folders.page"];
    const totalFilesFolderPages = Math.ceil((total) / pageSize);


    const shouldSearchGoogleDrive = organizationStore.organization.json_data?.settings?.identity?.provider === "google" &&
        organizationStore.organization.json_data.settings.identity.google.searchDrive && isSchoolBlocks;

    const onClick = () => {
        props.searchTypes.includes("google_drive") ? props.setSearchTypes(v =>
            v.filter(t => t !== "google_drive")
        ) : props.setSearchTypes(v => ["google_drive", ...v]);
    }

    const buttonText = props.searchTypes.includes("google_drive") ? "Search site files" : "Search Google Drive";

    const googleDriveOption = shouldSearchGoogleDrive && <div style={{marginBottom: 5}}>
        <ExpandYourSearchInfoBox
            onClick={onClick}
            buttonText={buttonText}
            searchType={"files_and_folders"}
        />
    </div>

    return (
        <ResultsHOC
            isLoading={props.results?.files_and_folders === undefined}
            isValidating={props.isValidating}
            resultsCount={total}
            searchTypes={props.searchTypes}
            thisComponentType={googleDriveResults ? "google_drive" : "files_and_folders"}
            searchTerm={props.searchTerm}
            noResultsString={"documents"}
            noResultsOptions={googleDriveOption}
        >
            {googleDriveOption}
            <FilesList
                files_folders={data}
                aboveTheFold={true}
            />
            <PaginationFooter
                currentPage={page}
                paginationIcons={[<>Prev</>, <>Next</>]}
                setPage={page => props.setFilters(v => ({
                    ...v,
                    "files_and_folders.page": page,
                }))}
                totalPages={totalFilesFolderPages} />
        </ResultsHOC>
    )
}
